export type Page = string;

export type PageStackState = Page[];

export const INITIAL_PAGE_STACK_STATE: PageStackState = [];
